export const greyBlue = {
  '50': '#F8FCFF',
  '100': '#F3F7FC',
  '200': '#EEF2F7',
  '300': '#E4E8ED',
  '400': '#C2C6CB',
  '500': '#A4A8AD',
  '600': '#7A7E83',
  '700': '#66696E',
  '800': '#474A4E',
  '900': '#25282C'
};

export const darkBlue = {
  '50': '#D2F4FF',
  '100': '#B0DFF4',
  '200': '#92C5DE',
  '300': '#71ACC8',
  '400': '#5698B6',
  '500': '#3885A5',
  '600': '#297693',
  '700': '#18617C',
  '800': '#054E66',
  '900': '#00394E'
};
